export type AppointmentTypeBehaviorLike = "padrao" | "retorno" | "aplicacao" | "banho_tosa";

interface AppointmentTypeBehaviorSource {
  id: string;
  behavior: string;
}

export function resolveAppointmentTypeBehavior({
  typeId,
  embeddedBehavior,
  appointmentTypes,
}: {
  typeId?: string | null;
  embeddedBehavior?: string | null;
  appointmentTypes: AppointmentTypeBehaviorSource[];
}): string | null {
  if (embeddedBehavior) return embeddedBehavior;
  if (!typeId) return null;

  return appointmentTypes.find((appointmentType) => appointmentType.id === typeId)?.behavior ?? null;
}
